import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";

import { BODY_TYPE_OPTIONS } from "layouts/dutyEstimator/constants";

const bodyTypeLabel = (value) => BODY_TYPE_OPTIONS.find((o) => o.value === value)?.label || value;

export default function freightRateTableData({ freightRateList = [], onEdit, onDelete }) {
  return {
    columns: [
      { Header: "Body Type", accessor: "bodyType", width: "34%", align: "left" },
      { Header: "Freight (USD)", accessor: "freightUSD", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: freightRateList.map((rate) => ({
      bodyType: (
        <MDBox>
          <MDTypography variant="button" fontWeight="medium" display="block">
            {rate?.label || bodyTypeLabel(rate?.bodyType)}
          </MDTypography>
          {rate?.description ? (
            <MDTypography variant="caption" color="text">
              {rate.description}
            </MDTypography>
          ) : null}
        </MDBox>
      ),
      freightUSD: (
        <MDTypography variant="button" fontWeight="bold">
          ${Number(rate?.freightUSD ?? 0).toLocaleString()}
        </MDTypography>
      ),
      status: (
        <Chip
          size="small"
          label={rate?.isActive === false ? "Inactive" : "Active"}
          sx={{
            backgroundColor: rate?.isActive === false ? "#eeeeee" : "#e8f5e9",
            color: rate?.isActive === false ? "#616161" : "#2e7d32",
            fontWeight: 600,
          }}
        />
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <Button size="small" onClick={() => onEdit(rate)}>
            Edit
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => onDelete(rate?.id)}
            sx={{ backgroundColor: "#d32f2f", color: "#fff", "&:hover": { backgroundColor: "#9a0007" } }}
          >
            Delete
          </Button>
        </MDBox>
      ),
    })),
  };
}
